import * as types from '../actions/types';

const initialState = {
    searchdata: ''
}

export default function SearchpgmReducer(state = initialState, action = undefined) {
    switch (action.type) {
        case types.PGM_SEARCH_DATA:
            return {
               
                searchdata:action?.payload,
            } 
        default:
            return state
    }
}
